import {useState} from "react"

const INIT_STATE = {itemId: null, elementIndex: 0}

export const useCanvasHandler = () => {
    const [state, setState] = useState(INIT_STATE)

    const set = (itemId, elementIndex) => {
        setState({itemId, elementIndex})
    }

    const getItemId = () => {
        return state.itemId
    }

    const getElementIndex = () => {
        return state.elementIndex
    }

    const hasItem = () => {
        return getItemId() !== null
    }

    const unset = () => {
        setState(INIT_STATE)
    }

    return {
        handlerSet: set,
        handlerGetItemId: getItemId,
        handlerGetElementIndex: getElementIndex,
        handlerHasItem: hasItem,
        handlerUnset: unset,
    }
}